module.exports = __webpack_public_path__ + "static/your-foods-roots.f85c54ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/your-foods-roots.svg
// module id = 409
// module chunks = 267508049536846